import { render, staticRenderFns } from "./InputDireccion.vue?vue&type=template&id=09477ed4&scoped=true&"
import script from "./InputDireccion.vue?vue&type=script&lang=js&"
export * from "./InputDireccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09477ed4",
  null
  
)

export default component.exports